import { fluid } from '@helpers/fluid';
import { contentStyles } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
import { CtaCardsStyles } from '../CtaCards/CtaCards.styles';
const Container = styled(SectionWrapper) `
  + ${CtaCardsStyles.Container} {
    padding-top: 0;

    ${SectionWrapperStyles.Inner} {
      padding-top: 0;
    }
  }
`;
const Inner = styled.div ``;
const Content = styled.div `
  ${contentStyles};

  h1,
  .h1-styles,
  h2,
  .h2-styles,
  h3,
  .h3-styles {
    margin-top: 2em;
  }

  h4,
  .h4-styles,
  h5,
  .h5-styles,
  h6,
  .h6-styles {
    margin: 0 0 ${fluid(12, 18)};
  }

  ${Inner}[data-alignment='center'] & {
    text-align: center;

    ul,
    ol {
      text-align: left;
    }
  }

  ${Inner}[data-alignment='right'] & {
    text-align: right;

    ul,
    ol {
      text-align: left;
    }
  }
`;
export const RichTextStyles = {
    Container,
    Content,
    Inner,
};
